import React from "react";
import "./ContactHeroSection.css";
import Shape from "../Shape/Shape";
import shape1 from "../../assets/shape1.svg";
import shape2 from "../../assets/shape2.svg";
import shape3 from "../../assets/shape3.svg";
import emailIcon from "../../assets/email-icon.svg";
import locationIcon from "../../assets/location-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg";

const ContactHeroSection = () => {
  const handleEmailClick = () => {
    window.location.href = "mailto:hapycandytoys@gmail.com";
  };

  const handlePhoneClick = () => {
    navigator.clipboard.writeText("+923219645633");
    alert("Phone number copied to clipboard");
  };

  return (
    <section className="contact-hero-section">
      <div className="contact-hero-content">
        <div className="left-content">
          <h2 className="title">Say Hello!</h2>
        </div>
        <div className="right-content">
          <p className="tagline">Our friendly team is always here to chat.</p>
        </div>
        <Shape svgPath={shape1} className="contact-hero-shape1" />
        <Shape svgPath={shape2} className="contact-hero-shape2" />
        <Shape svgPath={shape3} className="contact-hero-shape3" />
      </div>
      <div className="contact-methods">
        <div className="contact-method">
          <div className="icon-container">
            <img
              src={emailIcon}
              alt="Email Icon"
              className="icon"
              onClick={handleEmailClick}
            />
          </div>
          <p>Email</p>
          <p>Our friendly team is here to help</p>
          <p className="contact-info" onClick={handleEmailClick}>
            hapycandytoys@gmail.com
          </p>
        </div>
        <div className="contact-method">
          <div className="icon-container">
            <img src={locationIcon} alt="Location Icon" className="icon" />
          </div>
          <p>Office</p>
          <p>Come say hello to our office HQ</p>
          <p className="contact-info">
            Export Prcocessing Zone State 3, 59-D, Gujranwala, Punjab
          </p>
        </div>
        <div className="contact-method">
          <div className="icon-container">
            <img
              src={phoneIcon}
              alt="Phone Icon"
              className="icon"
              onClick={handlePhoneClick}
            />
          </div>
          <p>Phone</p>
          <p>Mon-Fri from 8am to 5pm</p>
          <p className="contact-info" onClick={handlePhoneClick}>
            +923219645633
          </p>
        </div>
      </div>
      <div className="contact-hero-animation"></div>
    </section>
  );
};

export default ContactHeroSection;
